
function JiraLink({ issue_key }) {
	const jira_url = `https://focussis.atlassian.net/browse`;
	const issue    = issue_key?.replace(`.js`, ``);
	const link     = `${jira_url}/${issue}`;

	return <a href={link} target="_blank" rel="noreferrer">{issue}</a>
}

export default JiraLink;
